import { useState } from 'react'

const useBankAccountMethod = () => {
  const [showBankAccountDrawer, setShowBankAccountDrawer] = useState(false)

  const openBankAccountDrawer = () => {
    setShowBankAccountDrawer(true)
  }

  const closeBankAccountDrawer = () => {
    setShowBankAccountDrawer(false)
  }

  return {
    showBankAccountDrawer,
    setShowBankAccountDrawer,
    openBankAccountDrawer,
    closeBankAccountDrawer,
  }
}

export default useBankAccountMethod
